import { constantCreator } from '~/utils/constantsCreator';
import api from '~/utils/api';

const constant = constantCreator('popup');
const OPEN_TOUR_CATEGORY = constant('OPEN_TOUR_CATEGORY');
const OPEN_SUBSCRIBE = constant('OPEN_SUBSCRIBE');
const SUBSCRIBE_NEXT_STEP = constant('SUBSCRIBE_NEXT_STEP');
const SUBSCRIBE_EMAIL = constant('SUBSCRIBE_EMAIL', true);
const SHARE_FB_8 = constant('SHARE_FB_8');
const CLICK_BOOK_NOW_DTAC = constant('CLICK_BOOK_NOW_DTAC');

const initialState = {
  step: 1,
  isOpenSubscribe: false,
  isOpenTourCategory: false,
  link: '/',
  target: '_self',
  redirectCity: '',
  tourCategoryQuery: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case OPEN_TOUR_CATEGORY:
      return {
        ...state,
        isOpenTourCategory: action.open,
        link: action.link,
        target: action.target,
        redirectCity: action.redirectCity,
        tourCategoryQuery: action.query
      };
    case OPEN_SUBSCRIBE:
      return {
        ...state,
        isOpenSubscribe: action.open
      };
    case SUBSCRIBE_NEXT_STEP:
      return {
        ...state,
        step: state.step + 1
      };
    default:
      return state;
  }
}

export const analytics = {
  [OPEN_SUBSCRIBE]: (action, getState) => (
    action.open
      ? { name: 'Open Subscribe', category: 'Marketing Popup'}
      : {name: 'Close Subscribe', category: 'Marketing Popup', step: getState().popup.step}
  ),
  [SUBSCRIBE_NEXT_STEP]: (action, getState) => ({name: 'Next Step', category: 'Marketing Popup', currentStep: getState().popup.step}),
  [SUBSCRIBE_EMAIL]: action => ({name: 'Subscribe Email', category: 'Marketing Popup', email: action.email}),
  [SHARE_FB_8]: () => ({name: 'Share Facebook For 8%', category: 'Marketing Popup'}),
  [CLICK_BOOK_NOW_DTAC]: () => ({name: 'Click Book Now DTAC', category: 'Marketing Popup', providers: 'database'}),
};

export const actions = {
  shareFacebook: () => ({
    type: SHARE_FB_8,
  }),
  logClickBookNowDtac: () => ({
    type: CLICK_BOOK_NOW_DTAC,
  }),
  openSubscribe: (open = true) => ({
    type: OPEN_SUBSCRIBE,
    open,
  }),
  openTourCategory: (open = true, link = '/', target = '_self', redirectCity = '', query) => ({
    type: OPEN_TOUR_CATEGORY,
    open,
    link,
    target,
    redirectCity,
    query
  }),
  closeTourCategory: () => ({
    type: OPEN_TOUR_CATEGORY,
    open: false,
    slug: null,
  }),
  subscribeNextStep: () => ({
    type: SUBSCRIBE_NEXT_STEP,
  }),
  subscribeEmail: (email) => ({
    type: SUBSCRIBE_EMAIL,
    promise: api.post('/mail/subscribe', { email }),
    email,
  }),
};
